<template>
  <div class="group" :style="groupStyle()">
    <div class="items-container" :style="itemsContainerStyle()">
      <div v-for="(item, index) in items"
           class="nav-item"
           :key="item.id"
           :style="itemStyle(index, item)"
           @click="onItemClick(item)">
        <img class="item-img" :src="src(item)" alt/>
      </div>
    </div>
    <nav-group v-if="subGroup && subGroup.items" v-bind="subGroup"/>
  </div>
</template>

<script>
import {NAV_TYPE} from "@/pages/Campaign/utils/enum"
import {calcRem, calcRem750} from "@/pages/Campaign/utils/calcRem"
import {imgUrl} from "@/pages/Campaign/utils/img"
import {mapActions, mapState} from "vuex";

export default {
  name: "NavGroup",
  props: {
    // 导航样式类型
    styleType: String,
    // 导航所处层级
    level: Number,
    // 间距
    space: {
      // 内部上下间距
      vertical: Number,
      // 内部左右间距
      horizontal: Number,
      // 条目间间距
      between: Number
    },
    // 子条目数组
    items: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState(['anchor', 'navGroup']),
    selectedItem: function() {
      let { id } = this.anchor?.find(e => e?.level === this.level) || 0
      return this.items.find(e => e.id === id)
    },
    subGroup() {
      if (!this.selectedItem?.group) return null

      return {
        styleType: this.styleType,
        ...this.selectedItem.group
      }
    }
  },
  methods: {
    ...mapActions(['selectedNavItem']),
    groupStyle() {
      const direction = this.styleType === NAV_TYPE.LEFT_RIGHT ? 'row' : 'column'
      const flexGrow = NAV_TYPE.LEFT_RIGHT && this.level === 1 ? 0 : 1
      return {
        flexDirection: direction,
        flexGrow: flexGrow
      }
    },
    itemFlexDirection() {
      // 目前，只有只有左右布局的一级菜单为垂直排列
      return this.styleType === NAV_TYPE.LEFT_RIGHT && this.level === 1 ? 'column' : 'row'
    },
    itemsContainerStyle() {
      const paddingTop = calcRem(this.space?.top || 0)
      const paddingRight = calcRem(this.space?.right || 0)
      const paddingBottom = calcRem(this.space?.bottom || 0)
      const paddingLeft = calcRem(this.space?.left || 0)
      const flexGrow = this.itemFlexDirection() === 'column' ? 0 : 1
      return {
        flexGrow: flexGrow,
        flexDirection: this.itemFlexDirection(),
        padding: `${paddingTop} ${paddingRight} ${paddingBottom} ${paddingLeft}`,
      }
    },
    itemStyle(index, item) {
      if (!item) return

      // 如果为水平排列，加左右间距；如果为垂直排列，加上下间距
      const marginStart = calcRem(this.space.between / 2)
      const marginEnd = calcRem(this.space.between / 2)

      // 使用选中的图片尺寸作为控价的尺寸
      const isFlexRow = this.itemFlexDirection() === 'row'
      const showImg = item === this.selectedItem ? item.imgSelect : item.imgUnselect
      const w = calcRem750(showImg?.width || 0)
      const h = calcRem750(showImg?.height || 0)

      return {
        width: w,
        height: h,
        marginLeft: isFlexRow ? marginStart : '0',
        marginTop: isFlexRow ? '0' : marginStart,
        marginRight: isFlexRow ? marginEnd : '0',
        marginBottom: isFlexRow ? '0' : marginEnd,
      }
    },
    src(item) {
      if (!item) return ''
      const img = item === this.selectedItem ? item.imgSelect : item.imgUnselect
      return imgUrl(img)
    },
    onItemClick(item) {
      this.selectedNavItem(item)
      this.onItemClickSensor(item.level)
    },
    onItemClickSensor(clickItemLevel) {
      const itemInfo = (group, id) => {
        if (!group?.items || !id || id <= 0) return [null, 0, null]

        const item = group.items.find(e => e.id === id)
        if (!item || item.level > clickItemLevel) return [null, 0, null]

        const name = item.name
        const index = group.items.indexOf(item)

        return [name, index + 1, item]
      }

      const [firstName, firstIndex, firstItem] = itemInfo(this.navGroup, this.anchor?.[0]?.id)
      const [secondName, secondIndex, secondItem] = itemInfo(firstItem?.group, this.anchor?.[1]?.id)
      const [thirdName, thirdIndex] = itemInfo(secondItem?.group, this.anchor[2]?.id)


      const padZero = n => n.toString().padStart(2, '0')

      this.$sensors.track('bookmark_click', {
        page_name: `承接页-${document.title}`,
        level1_text: firstName,
        level2_text: secondName,
        level3_text: thirdName,
        cur_spm: `1001.${this.$route.params.id}.loc2.${padZero(firstIndex)}${padZero(secondIndex)}${padZero(thirdIndex)}`
      })
    }
  }
}
</script>

<style lang="less" scoped>
.group {
  display: flex;
  width: 100%;

  .items-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
  }

  .item-img {
    width: 100%;
    height: 100%;
  }
}
</style>
